import { useState } from "react";

import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../utils/axios";
import {
  setCreateQuickPayRequest,
  setQuickPayDesign,
  setQuickPayList,
  setQuickPayDetails,
  setShowQuickPayDetails,
  setQuickPayReduxList,
  setQuickPayTemplate,
} from "../features/QuickPaySlice";
import { useDispatch } from "react-redux";
import { setRequestData } from "../features/transactionDetailsSlice";
import axios from "axios";
import { config } from "../utils/Constants";

function QuickPayApi() {
  const MerchantPortalAxios = useMerchantPortalAxios();
  const MerchantPortalAxios1 = useMerchantPortalFormData();
  const CustomMerchantPortalClient = MerchantPortalAxios;
  CustomMerchantPortalClient.defaults.timeout = 600000;
  const CustomMerchantPortalClient1 = MerchantPortalAxios1;
  CustomMerchantPortalClient1.defaults.timeout = 600000;

  const dispatch = useDispatch();

  const URL = config.url;

  const GetQuickPayTemplate = async () => {
    const res = await MerchantPortalAxios.get(
      "/v1/QuickPay/GetQuickPayTemplate"
    );
    if (res) {
      dispatch(setQuickPayTemplate(res.data));
    }
  };

  const GetQuickPayDesign = async () => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/QuickPay/GetQuickPayDesign",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        }
      );

      if (response) {
        dispatch(setQuickPayDesign(response?.data?.Payload?.UploadInterface));
        return response?.data?.Payload?.UploadInterface;
      }
    } catch (error) {
      console.error("Error fetching Quick Pay design", error);
    }
  };

  const CreateQuickPayRequest = async () => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/QuickPay/CreateQuickPayRequest",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        }
      );

      if (response) {
        dispatch(setCreateQuickPayRequest(response?.data?.Payload));
        return response?.data?.Payload;
      }
    } catch (error) {
      console.error("Error fetching Quick Pay design", error);
    }
  };

  const UploadQuickPay = async (payload) => {
    if (payload.formFile) {
      const fileData = payload.formFile.split(",")[1];
      const mimeType = payload.formFile.split(":")[1].split(";")[0];
      const byteCharacters = atob(fileData);
      const byteArrays = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
      payload.formFile = new File([byteArrays], payload?.ReasonFileName, {
        type: mimeType,
      });
    }
    const { ReasonFileName, ...newPayload } = payload;
    const response = await CustomMerchantPortalClient1.post(
      "/v1/QuickPay/UploadQuickPay",
      newPayload
    );
    return response.data;
  };

  const PushQuickPay = async (payload) => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/QuickPay/PushQuickPay",
        payload
      );
      return response?.data?.Payload;
    } catch (e) {
      console.warn(e);
      throw e;
    }
  };

  const PushNewQuickPayEmployees = async (payload) => {
    const res = await MerchantPortalAxios.post(
      "/v1/QuickPay/PushNewQuickPayEmployees",
      payload
    );
    return res?.data?.Payload;
  };

  const GetQuickPayList = async () => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/QuickPay/GetQuickPayList",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        }
      );

      if (response) {
        dispatch(setQuickPayList(response?.data?.Payload?.quickPays));
        return response?.data?.Payload?.quickPays;
      }
    } catch (error) {
      console.error("Error fetching Quick Pay design", error);
    }
  };

  const deletePendingApprovalQuickPay = async (payload) => {
    const res = await MerchantPortalAxios.post(
      "/v1/QuickPay/DeletePendingApprovalQuickPay",
      payload
    );
    GetQuickPayList();
    return res.data.Payload;
  };

  const deleteApprovalQuickPay = async (payload) => {
    const res = await MerchantPortalAxios.post(
      "/v1/QuickPay/DeleteActiveQuickPay",
      payload
    );
    GetQuickPayList();
    return res.data.Payload;
  };

  const GetQuickPayDetails = async (identifier, status) => {
    const res = await MerchantPortalAxios.post(
      "/v1/QuickPay/GetQuickPayDetails",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        Identifier: identifier,
        Status: status,
      }
    );

    dispatch(
      setQuickPayReduxList({
        list: res.data.Payload.corporateQuickPays,
        status: res.data.Payload.Status,
      })
    );

    return res.data.Payload;
  };

  const UploadNewQuickPayEmployees = async (payload) => {
    if (payload.formFile) {
      const fileData = payload.formFile.split(",")[1];
      const mimeType = payload.formFile.split(":")[1].split(";")[0];
      const byteCharacters = atob(fileData);
      const byteArrays = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
      payload.formFile = new File([byteArrays], payload?.ReasonFileName, {
        type: mimeType,
      });
    }
    const { ReasonFileName, ...newPayload } = payload;
    const response = await CustomMerchantPortalClient1.post(
      "/v1/QuickPay/UploadNewQuickPayEmployees",
      newPayload
    );
    return response.data;
  };

  const DeleteSingleUserQuickPay = async (payload) => {
    const res = await MerchantPortalAxios.post(
      "/v1/QuickPay/DeleteSingleUserQuickPay",
      payload
    );
    return res.data.Payload;
  };

  const EditSingleUserQuickPay = async (payload) => {
    const res = await MerchantPortalAxios.post(
      "/v1/QuickPay/EditSingleUserQuickPay",
      payload
    );
    return res.data.Payload;
  };

  const GetQuickPaySummary = async (checkerAdvanceID) => {
    const payload = {
      SessionID: sessionStorage.getItem("SessionID"),
      CheckerAdvanceId: checkerAdvanceID,
    };

    try {
      const response = await MerchantPortalAxios.post(
        "/v1/QuickPay/GetPendingQuickPayDetails",
        payload
      );
      dispatch(setShowQuickPayDetails(true));
      dispatch(setQuickPayDetails(response.data.Payload.quickPayDetailsList));
      dispatch(setRequestData({ field: "visible", value: false }));
    } catch (error) {
      console.error("Error fetching quick pay summary", error);
      throw error;
    }
  };

  const GetQuickPaySummaryMobile = async (checkerAdvanceID) => {
    const payload = {
      SessionID: sessionStorage.getItem("SessionMobile"),
      CheckerAdvanceId: checkerAdvanceID,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("TokenMobile"),
      },
    };

    try {
      const response = await axios.post(
        `${URL}/v1/QuickPay/GetPendingQuickPayDetails`,
        payload,
        config
      );
      dispatch(setShowQuickPayDetails(true));
      dispatch(setQuickPayDetails(response.data.Payload.quickPayDetailsList));
      dispatch(setRequestData({ field: "visible", value: false }));
    } catch (error) {
      console.error("Error fetching quick pay summary", error);
      throw error;
    }
  };

  const ApproveRejectQuickPay = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/QuickPay/ApproveRejectPendingQuickPayDetails",
      payload
    );
    return response.data.Payload;
  };

  const ApproveRejectQuickPayMobile = async (payload) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("TokenMobile"),
      },
    };

    const response = await axios.post(
      `${URL}/v1/QuickPay/ApproveRejectPendingQuickPayDetails`,
      payload,
      config
    );
    return response.data.Payload;
  };


  return {
    GetQuickPayTemplate,
    GetQuickPayDesign,
    UploadQuickPay,
    PushQuickPay,
    GetQuickPayList,
    deletePendingApprovalQuickPay,
    GetQuickPayDetails,
    DeleteSingleUserQuickPay,
    EditSingleUserQuickPay,
    GetQuickPaySummary,
    GetQuickPaySummaryMobile,
    ApproveRejectQuickPay,
    ApproveRejectQuickPayMobile,
    CreateQuickPayRequest,
    UploadNewQuickPayEmployees,
    PushNewQuickPayEmployees,
    deleteApprovalQuickPay,
  };
}

export default QuickPayApi;
